<template>
  <div class="lead-managers">
    <app-cells>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_performance_requests"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          shortcut="last60Days"
          @is-hidden="fetchPerformanceRequests"
          @input="onInputPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          ref="date_picker"
        />
      </div>
    </app-cells>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells><h2 class="title">Managers</h2></app-cells>
      <div v-for="manager of performance_requests" :key="manager.id" class="lead-managers__part">
        <div class="lead-managers__manager lead-managers__fstart">
          <div class="lead-managers__photo">
            <div class="lead-managers__avatar">
              <img :src="getUserAvatar(manager.manager.crop.crop_url)" alt="Avatar">
            </div>
            <div class="lead-managers__info">
              <span class="lead-managers__name">{{ manager.manager.full_name }}</span>
              <span class="lead-managers__position">Sales manager</span>
              <span class="lead-managers__seniority">{{ manager.seniority || 'No employment date' }}</span>
            </div>
          </div>
          <div class="performance-requests__card">
            <div class="performance-requests__blocks">
              <div
                v-for="block in blocks_config"
                :key="block.key"
                class="performance-requests__block"
                :class="{ 'performance-requests__block--other': block.key === 'other' }"
              >
                <div class="performance-requests__general">
                  <div class="lead-managers__diagram">
                    <div class="lead-managers__diagram-piece left" :class="{'over50': getBlockRate(manager, block.key) >= 50}"></div>
                    <div class="lead-managers__diagram-piece right" :class="{'over50': getBlockRate(manager, block.key) >= 50}" :style="{'transform': `rotate(${(360 * getBlockRate(manager, block.key) / 100) + 180}deg)` }"></div>
                    <span class="lead-managers__diagram-text">{{ getBlockRate(manager, block.key) }}%</span>
                  </div>
                  <div class="performance-requests__conversion">
                    <strong class="performance-requests__subtitle">{{ block.title }}</strong>
                    <div class="performance-requests__columns">
                      <div v-for="(chunk, index) in getFieldChunks(block.fields)" :key="index" class="performance-requests__column">
                        <div v-for="item in chunk" :key="item.key" class="lead-managers__conversion-line">
                          <span>{{ item.label }}:</span>
                          <b>{{ formatNumber(getBlockValue(manager, block.key, item.key)) }}</b>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="performance-requests__total">
                  <strong class="performance-requests__subtitle">Total Sales</strong>
                  <div class="performance-requests__total-grid">
                    <div class="lead-managers__amount">
                      <img src="@/assets/img/lead-amount.svg" alt="Amount">
                      <span class="lead-managers__row-value">{{ formatNumber(getBlockTotalSalesValue(manager, block.key, 'amount')) }}$</span>
                    </div>
                    <div class="lead-managers__amount">
                      <img src="@/assets/img/lead-commission.svg" alt="Commission">
                      <span class="lead-managers__row-value">{{ formatNumber(getBlockTotalSalesValue(manager, block.key, 'commission')) }}$</span>
                    </div>
                    <div class="lead-managers__amount">
                      <img src="@/assets/img/lead-discount.svg" alt="Discounts">
                      <span class="lead-managers__row-value">{{ formatNumber(getBlockTotalSalesValue(manager, block.key, 'discounts')) }}$</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { getLeadsAnalyticsManagersPerfomance } from '@/http'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'CRMAnalyticsPerformanceRequests',
  components: { VueCtkDateTimePicker },
  data() {
    return {
      is_loaded: false,
      filter_dates: null,
      custom_shortcuts: [
        { key: 'thisMonth', label: 'This month', value: 'month' },
        { key: 'lastMonth', label: 'Last month', value: '-month' },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'last180Days', label: 'Last 180 days', value: 180 },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' },
      ],
      performance_requests: [],
      blocks_config: [
        {
          key: 'general',
          title: 'General',
          fields: [
            { label: 'Requests', key: 'requests' },
            { label: 'Assigned', key: 'assigned' },
            { label: 'Created', key: 'created' },
            { label: 'Deposit', key: 'deposit' },
            { label: 'Regular', key: 'regular' },
            { label: 'Agents', key: 'agents' },
            { label: 'Agents (PF)', key: 'agents_preffered' },
            { label: 'Confirmed', key: 'confirmed' },
          ],
        },
        {
          key: 'regular',
          title: 'Regular',
          fields: [
            { label: 'Requests', key: 'requests' },
            { label: 'Assigned', key: 'assigned' },
            { label: 'Created', key: 'created' },
            { label: 'Website', key: 'website' },
            { label: 'Chat', key: 'chat' },
            { label: 'WhatsApp', key: 'whatsapp' },
            { label: 'Other', key: 'other' },
            { label: 'Confirmed', key: 'confirmed' },
          ],
        },
        {
          key: 'deposits',
          title: 'Deposits',
          fields: [
            { label: 'Requests', key: 'requests' },
            { label: 'Confirmed', key: 'confirmed' },
          ],
        },
        {
          key: 'agents_preffered',
          title: 'Agents (PF)',
          fields: [
            { label: 'Requests', key: 'requests' },
            { label: 'Confirmed', key: 'confirmed' },
          ],
        },
        {
          key: 'website',
          title: 'Website',
          fields: [
            { label: 'Requests', key: 'requests' },
            { label: 'Assigned', key: 'assigned' },
            { label: 'Created', key: 'created' },
            { label: 'Confirmed', key: 'confirmed' },
          ],
        },
        {
          key: 'chat',
          title: 'Chat',
          fields: [
            { label: 'Requests', key: 'requests' },
            { label: 'Assigned', key: 'assigned' },
            { label: 'Created', key: 'created' },
            { label: 'Confirmed', key: 'confirmed' },
          ],
        },
        {
          key: 'whatsapp',
          title: 'WhatsApp',
          fields: [
            { label: 'Requests', key: 'requests' },
            { label: 'Assigned', key: 'assigned' },
            { label: 'Created', key: 'created' },
            { label: 'Confirmed', key: 'confirmed' },
          ],
        },
        {
          key: 'other',
          title: 'Other',
          fields: [
            { label: 'Requests', key: 'requests' },
            { label: 'Assigned', key: 'assigned' },
            { label: 'Created', key: 'created' },
            { label: 'Confirmed', key: 'confirmed' },
          ],
        },
      ],
    }
  },
  methods: {
    getFieldChunks(fields) {
      const chunks = []

      for (let i = 0; i < fields.length; i += 4) {
        chunks.push(fields.slice(i, i + 4))
      }

      return chunks
    },
    getBlockData(manager, blockKey) {
      return manager?.[blockKey] || {}
    },
    getBlockRate(manager, blockKey) {
      return Number(this.getBlockData(manager, blockKey).rate || 0)
    },
    getBlockValue(manager, blockKey, key) {
      return this.getBlockData(manager, blockKey)?.[key] || 0
    },
    getBlockTotalSalesValue(manager, blockKey, key) {
      return this.getBlockData(manager, blockKey)?.total_sales?.[key] || 0
    },
    onInputPicker() {
      if (!this.$refs.date_picker.pickerOpen) this.fetchPerformanceRequests()
    },
    async fetchPerformanceRequests() {
      this.is_loaded = false

      const response = await getLeadsAnalyticsManagersPerfomance({
        from_date: this.filter_dates?.start,
        to_date: this.filter_dates?.end
      })
      this.performance_requests = response.data

      this.is_loaded = true
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug2.jpg')
    },
    formatNumber(value) {
      return Number(value || 0).toLocaleString()
    },
  }
}
</script>

<style scoped>
.lead-managers__manager {
  display: grid;
  grid-template-columns: 1fr;
  align-items: start;
  row-gap: 16px;
}

.performance-requests__card {
  padding-bottom: 6px;
}

.performance-requests__blocks {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
  align-items: flex-start;
  width: 100%;
}

.performance-requests__block {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  min-width: 0;
}

.performance-requests__block--other {
  grid-column: 1 / 2;
}

.performance-requests__general {
  display: flex;
  align-items: center;
  gap: 18px;
}

.performance-requests__conversion {
  flex-shrink: 0;
}

.performance-requests__total {
  min-width: 140px;
  flex-shrink: 0;
}

.performance-requests__subtitle {
  display: block;
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
}

.performance-requests__columns {
  display: grid;
  grid-template-columns: repeat(2, 110px);
  gap: 10px;
}

.performance-requests__column {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.performance-requests__total-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.performance-requests__total-grid .lead-managers__amount {
  min-width: 0;
}

@media (max-width: 768px) {
  .lead-managers__manager {
    grid-template-columns: 1fr;
    row-gap: 16px;
  }

  .performance-requests__card {
    overflow-x: visible;
  }

  .performance-requests__blocks {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .performance-requests__block {
    flex-direction: column;
    gap: 12px;
  }

  .performance-requests__general {
    flex-direction: column;
    align-items: flex-start;
  }

  .performance-requests__columns {
    grid-template-columns: 1fr;
  }
}
</style>
